"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorklistListSchema = exports.WorkflowObjectSchema = exports.WorkflowTypeSchema = void 0;
const zod_1 = require("zod");
const list_1 = require("../list");
exports.WorkflowTypeSchema = zod_1.z
    .enum(['survey', 'analysis', 'interview'])
    .openapi('WorkflowType');
exports.WorkflowObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    slug: exports.WorkflowTypeSchema,
    displayName: zod_1.z.string(),
    description: zod_1.z.string(),
    summary: zod_1.z.string(),
    tagline: zod_1.z.string(),
    action: zod_1.z.string(),
    object: zod_1.z.literal('workflow'),
    schema: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
})
    .openapi('WorkflowObject');
exports.WorklistListSchema = (0, list_1.ListResponseSchema)(exports.WorkflowObjectSchema, {
    title: 'WorkflowList',
});
//# sourceMappingURL=workflowSchema.js.map